var map = {
	"./cn/北京通州华仁学校/wap.svg": "TKZT",
	"./en/北京通州华仁学校/wap.svg": "qG7D"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KgFv";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/北京通州华仁学校\/wap\.svg$
// module id = KgFv
// module chunks = 16